<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'

interface Props {
  account: object | null,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(0)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {

}

const handleChangePageSize = (size: number) => {

}

const requestFetchData = async () => {
  try{
    dataSource.value = {
      list: [
        { id: 1, code: '#389004', profile_pic: 'https://images.unsplash.com/photo-1600716051809-e997e11a5d52?q=80&w=1700&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', fullname: 'Nguyễn Văn A', phone: '0909 090 839', email: 'test@yopmail.com', type: 'Cá nhân', rate: 2333, level: 'NV Môi giới', submem: 23, regdate:  '2025-05-01 00:00:00' },
        { id: 1, code: '#389004', profile_pic: 'https://images.unsplash.com/photo-1600716051809-e997e11a5d52?q=80&w=1700&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', fullname: 'Nguyễn Văn A', phone: '0909 090 839', email: 'test@yopmail.com', type: 'Cá nhân', rate: 2333, level: 'NV Môi giới', submem: 23, regdate:  '2025-05-01 00:00:00' },
        { id: 1, code: '#389004', profile_pic: 'https://images.unsplash.com/photo-1600716051809-e997e11a5d52?q=80&w=1700&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', fullname: 'Nguyễn Văn A', phone: '0909 090 839', email: 'test@yopmail.com', type: 'Cá nhân', rate: 2333, level: 'NV Môi giới', submem: 23, regdate:  '2025-05-01 00:00:00' },
        { id: 1, code: '#389004', profile_pic: 'https://images.unsplash.com/photo-1600716051809-e997e11a5d52?q=80&w=1700&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', fullname: 'Nguyễn Văn A', phone: '0909 090 839', email: 'test@yopmail.com', type: 'Cá nhân', rate: 2333, level: 'NV Môi giới', submem: 23, regdate:  '2025-05-01 00:00:00' },
        { id: 1, code: '#389004', profile_pic: 'https://images.unsplash.com/photo-1600716051809-e997e11a5d52?q=80&w=1700&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', fullname: 'Nguyễn Văn A', phone: '0909 090 839', email: 'test@yopmail.com', type: 'Cá nhân', rate: 2333, level: 'NV Môi giới', submem: 23, regdate:  '2025-05-01 00:00:00' },
      ],
      totalPage: 2,
      totalRecords: 16,
    }
  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '7') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        code: { label: 'CODE', component: TextCell, visible: true, class: '', sort: false, config: {} },
        profile_pic: { label: 'Avatar', component: ThumbCell, visible: true, class: '', sort: false, config: {width: '40px', height: '40px', borderRadius: '4px'} },
        fullname: { label: 'Tên đầy đủ', component: TextCell, visible: true, class: '', sort: false, config: {} },
        phone: { label: 'Số điện thoại', component: TextCell, visible: true, sort: false, class: '', config: {} },
        email: { label: 'Email', component: TextCell, visible: true, sort: false, config: {} },
        type: { label: 'Loại hình', component: TextCell, visible: true, sort: false, config: {} },
        rate: { label: 'Điểm', component: TextCell, visible: true, sort: false, config: {} },
        level: { label: 'Cấp độ', component: TextCell, visible: true, sort: false, config: {} },
        submem: { label: 'Thành viên hệ thống', component: TextCell, visible: true, sort: false, config: {} },
        regdate: { label: 'Thời gian giao dịch', component: DateTimeCell, visible: true, class: '', sort: false, config: {} },

      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
